/**
 * Gets the payment method label from its value
 * @param method Payment method value
 * @returns Payment method display label
 */
export function getPaymentMethodLabel(method: string): string {
  const paymentMethods = [
    { label: 'Cash', value: 'cash' },
    { label: 'Check', value: 'check' },
    { label: 'Bank Transfer', value: 'bank_transfer' },
    { label: 'Credit Card', value: 'credit' },
    { label: 'Debit Card', value: 'debit' },
  ]
  const methodObj = paymentMethods.find((m) => m.value === method)
  return methodObj ? methodObj.label : method
}

/**
 * Gets the payment status label from its value
 * @param status Payment status value
 * @returns Payment status display label
 */
export function getPaymentStatusLabel(status: string): string {
  const paymentStatuses = [
    { label: 'Pending', value: 'pending' },
    { label: 'Completed', value: 'completed' },
    { label: 'Cancelled', value: 'cancelled' },
  ]
  const statusObj = paymentStatuses.find((s) => s.value === status)
  return statusObj ? statusObj.label : status
}

/**
 * Gets the severity class for a payment status
 * @param status Payment status value
 * @returns PrimeVue severity class
 */
export function getPaymentStatusSeverity(status: string): string {
  switch (status) {
    case 'completed':
      return 'success'
    case 'pending':
      return 'warning'
    case 'cancelled':
      return 'danger'
    default:
      return 'info'
  }
}

/**
 * Common payment methods options for dropdowns
 */
export const paymentMethods = [
  { label: 'Cash', value: 'cash' },
  { label: 'Check', value: 'check' },
  { label: 'Bank Transfer', value: 'bank_transfer' },
  { label: 'Credit Card', value: 'credit' },
  { label: 'Debit Card', value: 'debit' },
]

/**
 * Common payment status options for dropdowns
 */
export const paymentStatuses = [
  { label: 'Pending', value: 'pending' },
  { label: 'Completed', value: 'completed' },
  { label: 'Cancelled', value: 'cancelled' },
]

/**
 * Common transaction types for dropdowns
 */
export const transactionTypes = [
  { label: 'Purchase', value: 'purchase', icon: 'pi pi-cart-plus' },
  { label: 'Sale', value: 'sale', icon: 'pi pi-dollar' },
]
